import { Link, Paper, styled } from '@mui/material'
import { CardContainer } from '../VenueCardContainerStyles'
import {
  CustomAccordion,
  CustonAccordionSummary,
  CustonAccordionDetails,
} from '../../Drawer/Drawer'
import { LinkChip } from '../../Chips'
import { MinusDrawerIcon, PlusDrawerIcon } from '../../../Icons'
import { Dispatch, SetStateAction } from 'react'

const CardAccordionSummary = styled(CustonAccordionSummary)(({ theme }) => ({
  '& .MuiAccordionSummary-content': {
    margin: '0 auto 0 0',
  },
}))

export const CardAccordion = ({
  cards,
  open,
  setOpen,
}: {
  cards: JSX.Element[]
  open: boolean
  setOpen: Dispatch<SetStateAction<boolean>>
}): JSX.Element => {
  return (
    <Paper
      elevation={0}
      sx={{
        maxWidth: 1276,
        borderRadius: '0 0 8px 8px',
        margin: '0 auto 2rem',
        padding: '0 16px 16px',
      }}
    >
      <CustomAccordion disableGutters={true} expanded={open}>
        <CardAccordionSummary sx={{ paddingTop: '16px' }}>
          <h3
            style={{
              fontWeight: 600,
              fontSize: '1.25em',
              lineHeight: '1.5em',
              margin: 0,
            }}
          >
            More venues that could work for you
          </h3>
        </CardAccordionSummary>
        <CustonAccordionDetails>
          <CardContainer>{cards.map((card) => card)}</CardContainer>
        </CustonAccordionDetails>
      </CustomAccordion>
      <Link variant='anchor' component='button' onClick={() => setOpen(!open)}>
        <LinkChip
          sx={{ fontWeight: 600, marginTop: '24px' }}
          icon={open ? <MinusDrawerIcon /> : <PlusDrawerIcon />}
          label={
            open
              ? 'Show less venues'
              : `Show ${cards.length} more venue${cards.length > 1 ? 's' : ''}`
          }
        />
      </Link>
    </Paper>
  )
}
